export default __webpack_public_path__ + "static/media/chip50000.24bcfb83.png";